import { Helmet } from "react-helmet-async";

const SITE_URL = "https://kkacademy.ch";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const DEFAULT_KEYWORDS = [
  "KK Academy", "Kaaviyam", "Tanzschule", "Musikunterricht", "Kulturveranstaltungen",
  "Tamilische Tanzkurse", "Tamilische Musikworkshops", "Jugendgemeinschaft Tamilen",
  "Kurse für tamilische Jugendliche", "Tamilische Kultur Events", "Unity Dance Crew",
  "Mirudangam Unterricht", "Mirudangam", "Mirduthangam", "Mirduthangam Unterricht",
  "Workshops", "Events", "Kurse", "Tamilische Gemeinschaftsprojekte",
  "Tamilische Jugendprogramme", "Tamilische Tanzgruppen",
  "Musik und Tanz für Jugendliche", "Tamilische Kulturförderung",
  "Traditioneller tamilischer Tanz", "Community", "Tamilische Musikgruppen",
  "Tanz Crew", "Jugendkultur Tamilen", "Tamilische Musikinstrumente lernen",
  "Tamilische Tanzperformance", "Kaaviyam Kulturgruppe", "Unity Dance Events",
  "Tamilische Festivitäten", "Eventmanagement", "Bharatanatyam", "Bollywood",
  "Kuthu", "HipHop", "Wil SG", "Schweiz",
].join(", ");

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "MusicSchool",
  "name": "KK Academy – Academy of Performing Arts & Culture",
  "alternateName": ["KK Academy", "Kaaviyam Kandiah Academy"],
  "url": SITE_URL,
  "logo": `${SITE_URL}/logo.png`,
  "image": DEFAULT_IMAGE,
  "description":
    "KK Academy ist eine Schweizer Akademie für tamilische Musik, Tanz und Kultur. Mirudangam, Bollywood, Kuthu, HipHop und Bharatanatyam – Kurse, Workshops und Events für die tamilische Jugend und Community.",
  "telephone": "+41 79 396 66 60",
  "email": "kk@kkacademy.ch",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Wil SG",
    "postalCode": "9500",
    "addressCountry": "CH",
  },
  "areaServed": ["CH", "DE", "AT"],
  "sameAs": [],
  "knowsAbout": [
    "Mirudangam", "Bharatanatyam", "Bollywood", "Kuthu", "HipHop",
    "Tamilische Kultur", "Karnatische Musik", "Tamilischer Volkstanz",
  ],
};

export const Seo = ({
  title,
  description,
  keywords,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  lang = "de",
}) => {
  const fullTitle = title
    ? `${title} | KK Academy`
    : "KK Academy – Tamilische Musik, Tanz & Kultur · Wil SG Schweiz";
  const desc =
    description ||
    "KK Academy in Wil SG – Akademie für tamilische Musik & Tanz. Mirudangam-Unterricht, Bollywood, Kuthu, HipHop, Bharatanatyam Kurse, Workshops und das jährliche KAAVIYAM Kultur-Event.";
  const url = `${SITE_URL}${path}`;
  const allKeywords = keywords ? `${keywords}, ${DEFAULT_KEYWORDS}` : DEFAULT_KEYWORDS;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={allKeywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      <meta name="author" content="KK Academy" />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="KK Academy" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="KK Academy – Performing Arts & Culture" />
      <meta property="og:locale" content="de_CH" />
      <meta property="og:locale:alternate" content="en_US" />
      <meta property="og:locale:alternate" content="ta_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {/* hreflang */}
      <link rel="alternate" hrefLang="de" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="ta" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* Structured data */}
      <script type="application/ld+json">
        {JSON.stringify(ORGANIZATION_JSONLD)}
      </script>
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
